import { gql } from '@apollo/client';

export const CREATE_CALENDAR_RULERS = gql`
  mutation create_calendar_rulers($data: CreateCalendarRulersInputType!) {
    create_calendar_rulers(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const UPDATE_CALENDAR_RULERS = gql`
  mutation update_calendar_rulers($data: UpdateCalendarRulersInputType!) {
    update_calendar_rulers(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const CANCEL_SCHEDULE = gql`
  mutation cancel_schedule($data: CancelScheduleInputType!) {
    cancel_schedule(data: $data) {
      hasError
      message
      data
    }
  }
`;


export const DELETE_CALENDAR_RULER_BY_ID = gql`
  mutation delete_calendar_ruler_by_id($data: DeleteCalendarRulerByIdInputType!) {
    delete_calendar_ruler_by_id(data: $data) {
      hasError
      message
      data
    }
  }
`;


export const LIST_CALENDAR_RULER = gql`
  query list_calendar_ruler($data: ListCalendarRulerInputType!) {
    response: list_calendar_ruler(data: $data) {
      hasError
      data
      message
    }
  }
`;


export const GET_CALENDAR_RULER_BY_ID = gql`
  query get_calendar_ruler_by_id($data: GetCalendarRulerByIdInputType!) {
    get_calendar_ruler_by_id(data: $data) {
      hasError
      message
      data
    }
  }
`;


export const CREATE_SCHEDULE_LINK = gql`
  mutation create_schedule_link($data: CreateScheduleLinkInputType!) {
    create_schedule_link(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const GET_LINK_BY_AGENT_ID = gql`
  query get_link_by_agent_id($data: GetLinkByAgentIdInputType!) {
    get_link_by_agent_id(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_SCHEDULES_NEXT_N_DAYS = gql`
  query get_schedules_next_n_days($data: GetSchedulesNextNDaysInputType!) {
    get_schedules_next_n_days(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const RECREATE_SCHEDULER = gql`
  mutation recreate_scheduler($data: RecreateSchedulerInputType!) {
    recreate_scheduler(data: $data) {
      hasError
      message
      data
    }
  }
`;
